/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.20.2-27-g52fb3b68-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { KubernetesTargetAuthKubernetesTargetCertificateAuthFromJSONTyped, KubernetesTargetAuthKubernetesTargetCertificateAuthToJSON, } from './KubernetesTargetAuthKubernetesTargetCertificateAuth';
import { KubernetesTargetAuthKubernetesTargetTokenAuthFromJSONTyped, KubernetesTargetAuthKubernetesTargetTokenAuthToJSON, } from './KubernetesTargetAuthKubernetesTargetTokenAuth';
export function KubernetesTargetAuthFromJSON(json) {
    return KubernetesTargetAuthFromJSONTyped(json, false);
}
export function KubernetesTargetAuthFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    switch (json['kind']) {
        case 'Certificate':
            return Object.assign({}, KubernetesTargetAuthKubernetesTargetCertificateAuthFromJSONTyped(json, true), { kind: 'Certificate' });
        case 'Token':
            return Object.assign({}, KubernetesTargetAuthKubernetesTargetTokenAuthFromJSONTyped(json, true), { kind: 'Token' });
        default:
            throw new Error(`No variant of KubernetesTargetAuth exists with 'kind=${json['kind']}'`);
    }
}
export function KubernetesTargetAuthToJSON(value) {
    if (value == null) {
        return value;
    }
    switch (value['kind']) {
        case 'Certificate':
            return KubernetesTargetAuthKubernetesTargetCertificateAuthToJSON(value);
        case 'Token':
            return KubernetesTargetAuthKubernetesTargetTokenAuthToJSON(value);
        default:
            throw new Error(`No variant of KubernetesTargetAuth exists with 'kind=${value['kind']}'`);
    }
}
